import React from 'react';
import { Chapter } from '../../interfaces/chapters.interface';
import { ChapterForm } from './ChapterForm';

interface ChapterEditFormProps {
  chapter: Chapter;
  onChapterUpdated: () => void;
}

const ChapterEditForm: React.FC<ChapterEditFormProps> = ({ chapter, onChapterUpdated }) => {
  return (
    <ChapterForm
      mode="edit"
      initialChapter={chapter}
      onSubmitSuccess={onChapterUpdated}
    />
  );
};

export default ChapterEditForm;
